import { createReducer } from '@reduxjs/toolkit';

import { ISidebarState } from './interfaces';
import { Constants } from './constants';

const initialSidebarState: ISidebarState = {
    sidebarShown: false,
};

export const sidebarReducer = createReducer(initialSidebarState, {
    [Constants.SIDEBAR_SHOW]: (draftState) => {
        draftState.sidebarShown = true;
    },

    [Constants.SIDEBAR_HIDE]: (draftState) => {
        draftState.sidebarShown = false;
    },
});
